import type { ErrorModel } from 'app/src/model'
import { PortalDialog } from 'app/src/shared/components/Dialog'
import { convertError } from 'app/src/shared/helpers'
import errorBlock from 'app/static/images/error_block.png'
import { InputIcon } from 'primereact/inputicon'
import type React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router-dom'
import { Image } from './Image'
import { PageWidget } from './PageWidget'

export function UnrecoverableError(props?: { errorModel?: ErrorModel }) {
  const { t } = useTranslation('errors')
  const error = useRouteError()
  const convertedError = props?.errorModel ?? convertError<ErrorModel>(error)

  return (
    <div className='mt-2 min-h-5 text-center text-lg text-red-500'>
      {t(convertedError?.type ?? 'UnrecoverableErrorMessage', {
        defaultValue: t('UnrecoverableErrorMessage'),
      })}
    </div>
  )
}

export function SessionExpiredError() {
  const { t } = useTranslation('errors')
  const [errorModalVisible, setErrorModalVisible] = useState<boolean>(true)

  return (
    <div className='text-center'>
      {/* <InputIcon className='pi pi-calendar-times mt-6 text-5xl text-red-500'> </InputIcon>
      <div className='my-4 min-h-5 text-xl font-bold text-red-500'>{t('SessionExpiredMsg')}</div>
      <Button className='mt-6' rounded onClick={() => window.location.reload()}>
        {t('SessionExpiredBtnLabel')}
      </Button> */}

      {errorModalVisible && (
        <PortalDialog
          headerProps={{
            title: t('SessionExpiredMsg'),
          }}
          ptHeader='py-3'
          onHide={() => setErrorModalVisible(false)}
          footerProps={{
            okCallBack: () => {
              setErrorModalVisible(false)
              window.location.reload()
            },
            okLabel: t('SessionExpiredBtnLabel'),
          }}
          closable={false}
        >
          <div className='grid grid-cols-1 text-center'>
            <InputIcon className='pi pi-calendar-times mb-3 text-5xl text-red-500'> </InputIcon>
            <span>{t('SessionExpiredSuggestion')}</span>
          </div>
        </PortalDialog>
      )}
    </div>
  )
}

export function ErrorPage(props?: React.PropsWithChildren<{ errorMessage?: string }>) {
  const { t } = useTranslation('errors')

  return (
    <PageWidget>
      <div className='mb-2 flex flex-col'>
        <div className='mx-auto'>
          <div>
            <Image
              pt={{ image: { className: 'max-h-[257px]' } }}
              className='object-fit aspect-[3/2] max-h-[257px]'
              src={errorBlock}
              alt='Immagine di errore'
            />
          </div>
        </div>
        <div className='bold m-auto mx-auto mt-[24px] max-w-xl text-center text-4xl font-bold leading-[64px]'>
          <div dangerouslySetInnerHTML={{ __html: props?.errorMessage ?? t('UnrecoverableErrorMessage') }} />
        </div>
        {props?.children && <>{props.children}</>}
      </div>
    </PageWidget>
  )
}

export function ErrorCancelPage(props?: React.PropsWithChildren<{ errorTitle?: string; errorSubtitle?: string }>) {
  const { t } = useTranslation('errors')

  return (
    <PageWidget>
      <div className='mb-2 flex flex-col'>
        <div className='bold max-w-xxl m-auto mx-auto mt-[48px] text-center text-4xl font-bold'>
          <div dangerouslySetInnerHTML={{ __html: props?.errorTitle ?? t('UnrecoverableErrorMessage') }} />
        </div>
        <div className='mx-auto mt-[48px]'>
          <div>
            <Image
              pt={{ image: { className: 'max-h-[257px]' } }}
              className='object-fit aspect-[3/2] max-h-[257px]'
              src={errorBlock}
              alt='Immagine di errore'
            />
          </div>
        </div>
        <div className='m-auto mx-auto mt-[48px] max-w-xl text-center'>
          <div dangerouslySetInnerHTML={{ __html: props?.errorSubtitle ?? t('UnrecoverableErrorMessage') }} />
        </div>
        <div className='text mt-4 text-center'>{props?.children && <>{props.children}</>}</div>
      </div>
    </PageWidget>
  )
}
